import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BlocLoading } from '../ImportAll'
import './Bloc.css'

class BlocResultat extends Component {
    handleClickRedirectResultat() {
        window
            .open(
                '/projet#!/estimations?no=' + this.props.resultat_no_dossier,
                '_blank'
            )
            .focus()
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        const style = {
            display: 'table',
            minHeight: '125px',
        }

        var content

        if (this.props.comparer) {
            if (this.props.load) {
                content = (
                    <BlocLoading
                        message_principal="Envoi de votre demande en cours ..."
                        petite_ligne_1="Cela ne devrait pas durer longtemps."
                        petite_ligne_2="En cas de soucis réessayez ultérieurement ou contactez notre service téléphonique."
                    />
                )
            } else if (this.props.err) {
                content = (
                    <div className="Bloc fade-in bloc-full" style={style}>
                        <div className="simpleDoubleWord1 bold-font">
                            Erreur lors de l'envoi
                        </div>
                        <div className="simpleDoubleWord2">
                            Réessayez ultérieurement ou contactez notre service
                            téléphonique.
                        </div>
                    </div>
                )
            } else if (this.props.send) {
                style.height = '140px'

                content = (
                    <div className="Bloc BlocLoading fade-in bloc-full" style={style}>
                        <div className="simpleDoubleWord1 bold-font">
                            Envoi Réussi !
                        </div>
                        <div className="simpleDoubleWord2">
                            Merci à vous, votre demande a été envoyée.{' '}
                        </div>
                        <div className="simpleDoubleWord2">
                            Nous vous recontacterons très rapidement.
                        </div>
                    </div>
                )
            }
        } else if (this.props.simuler) {
            if (this.props.load) {
                content = (
                    <BlocLoading
                        message_principal="Envoi de votre demande en cours ..."
                        petite_ligne_1="Cela ne devrait pas durer longtemps."
                        petite_ligne_2="En cas de soucis réessayez ultérieurement ou contactez notre service téléphonique."
                    />
                )
            } else if (this.props.err) {
                content = (
                    <div className="Bloc fade-in bloc-full" style={style}>
                        <div className="simpleDoubleWord1 bold-font">
                            Erreur lors de l'envoi
                        </div>
                        <div className="simpleDoubleWord2">
                            Réessayez ultérieurement ou contactez notre service
                            téléphonique.
                        </div>
                    </div>
                )
            } else if (this.props.send) {
                if (this.props.resultat_no_dossier) {
                    content = (
                        <div className="Bloc BlocLoading fade-in bloc-full" style={style}>
                            <div className="simpleDoubleWord1 bold-font">
                                Envoi réussi.
                            </div>
                            <div className="simpleDoubleWord2">
                                Pour accèder aux résultat, cliquez sur le
                                boutton ci dessus :
                            </div>
                            <div
                                onClick={(e) =>
                                    this.handleClickRedirectResultat()
                                }
                                className="buttonRedirection"
                            >
                                Accèder aux résultats
                            </div>
                        </div>
                    )
                } else {
                    content = (
                        <BlocLoading
                            message_principal="Envoi Réussi !"
                            petite_ligne_1="Vous allez étre rediriger vers la page de résultat."
                        />
                    )
                }
            }
        }

        return <div>{content}</div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        resultat_no_dossier: state.answer['resultat_no_dossier'],
    }
}

export default connect(mapStateToProps)(BlocResultat)
